import { render, staticRenderFns } from "./proveedores.vue?vue&type=template&id=b9f77a4a&"
import script from "./proveedores.vue?vue&type=script&lang=js&"
export * from "./proveedores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports